import React, { useState } from 'react';
import { ChevronDown, Search, ShoppingCart, User, ShoppingBag, ArrowRight, Tag, Layers, Shield, Cpu, Package, Truck, Phone, Mail, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Footer } from '../components/Footer';
const megaColumns = [{
  heading: 'Identification Labels',
  icon: Tag,
  items: [{
    name: 'Lorem ipsum dolor sit',
    desc: 'Amet consectetur adipiscing elit sed do'
  }, {
    name: 'Sed do eiusmod tempor',
    desc: 'Incididunt ut labore et dolore magna'
  }, {
    name: 'Ut enim ad minim',
    desc: 'Veniam quis nostrud exercitation ullamco'
  }, {
    name: 'Duis aute irure dolor',
    desc: 'In reprehenderit in voluptate velit'
  }, {
    name: 'Excepteur sint occaecat',
    desc: 'Cupidatat non proident sunt in culpa'
  }]
}, {
  heading: 'Nameplates & Panels',
  icon: Layers,
  items: [{
    name: 'Adipiscing elit sed do',
    desc: 'Eiusmod tempor incididunt ut labore'
  }, {
    name: 'Labore et dolore magna',
    desc: 'Aliqua ut enim ad minim veniam quis'
  }, {
    name: 'Nostrud exercitation',
    desc: 'Ullamco laboris nisi ut aliquip ex ea'
  }, {
    name: 'Ex ea commodo consequat',
    desc: 'Duis aute irure dolor in reprehenderit'
  }, {
    name: 'Voluptate velit esse',
    desc: 'Cillum dolore eu fugiat nulla pariatur'
  }]
}, {
  heading: 'Security & Tamper',
  icon: Shield,
  items: [{
    name: 'Dolor in reprehenderit',
    desc: 'In voluptate velit esse cillum dolore'
  }, {
    name: 'Dolore eu fugiat nulla',
    desc: 'Pariatur excepteur sint occaecat'
  }, {
    name: 'Cupidatat non proident',
    desc: 'Sunt in culpa qui officia deserunt'
  }, {
    name: 'Deserunt mollit anim',
    desc: 'Id est laborum sed perspiciatis unde'
  }, {
    name: 'Nemo enim ipsam',
    desc: 'Voluptatem quia voluptas sit aspernatur'
  }]
}, {
  heading: 'Industrial Marking',
  icon: Cpu,
  items: [{
    name: 'Aspernatur aut odit',
    desc: 'Aut fugit sed quia consequuntur magni'
  }, {
    name: 'Magni dolores eos qui',
    desc: 'Ratione voluptatem sequi nesciunt neque'
  }, {
    name: 'Neque porro quisquam',
    desc: 'Est qui dolorem ipsum quia dolor sit'
  }, {
    name: 'Amet consectetur',
    desc: 'Adipisci velit sed quia non numquam'
  }, {
    name: 'Eius modi tempora',
    desc: 'Incidunt ut labore et dolore magnam'
  }]
}];
const navItems = ['Lorem Ipsum', 'Consectetur', 'Adipiscing', 'Eiusmod', 'Tempor'];
export function MegaMenuPage() {
  const [isOpen, setIsOpen] = useState(true);
  return <div className="min-h-screen bg-[#F4F5F7] font-sans text-[#0A1628]" data-id="element-1052">
      {/* Page header */}
      <div className="bg-white border-b border-slate-200 py-10" data-id="element-1053">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12" data-id="element-1054">
          <a href="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#0052CC] transition-colors mb-6" data-id="element-1055">
            <ChevronRight className="h-3.5 w-3.5 rotate-180" data-id="element-1056" /> Back to site
          </a>
          <h1 className="text-3xl md:text-4xl font-extrabold text-[#0A1628] tracking-tight mb-2" data-id="element-1057">
            Navigation concept — Mega menu
          </h1>
          <p className="text-slate-500 text-base max-w-xl" data-id="element-1058">
            Ecommerce-grade product navigation for a large industrial catalogue.
            Click the nav item to toggle the menu open and closed.
          </p>
        </div>
      </div>

      {/* Demo area */}
      <div className="py-12" data-id="element-1059">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12" data-id="element-1060">
          {/* Simulated sticky header */}
          <div className="border border-slate-300 overflow-hidden shadow-lg bg-white" data-id="element-1061">
            {/* Top bar */}
            <div className="bg-[#0A1628] px-8 py-2 flex items-center justify-between" data-id="element-1062">
              <div className="flex items-center gap-3 text-xs text-slate-400" data-id="element-1063">
                <Truck className="h-3.5 w-3.5 text-slate-500" data-id="element-1064" />
                <span data-id="element-1065">Free nationwide delivery on all orders</span>
                <span className="w-px h-3 bg-white/10" data-id="element-1066" />
                <span className="text-white/50" data-id="element-1067">
                  🇬🇧 UK manufacturer, Est. 2009
                </span>
              </div>
              <div className="hidden md:flex items-center gap-4 text-xs text-slate-400" data-id="element-1068">
                <span className="flex items-center gap-1.5" data-id="element-1069">
                  <Mail className="h-3 w-3" data-id="element-1070" /> lorem@ipsum.co.uk
                </span>
                <span className="w-px h-3 bg-white/10" data-id="element-1071" />
                <span className="flex items-center gap-1.5 font-bold text-white" data-id="element-1072">
                  <Phone className="h-3 w-3" data-id="element-1073" /> 01234 567890
                </span>
              </div>
            </div>

            {/* Main nav */}
            <div className="bg-white border-b border-slate-200 px-8 py-0" data-id="element-1074">
              <div className="flex items-center justify-between gap-8 h-16" data-id="element-1075">
                {/* Logo */}
                <div className="flex-shrink-0 h-8 w-28 bg-slate-100 border border-slate-200 flex items-center justify-center" data-id="element-1076">
                  <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-1077">
                    Logo
                  </span>
                </div>

                {/* Nav */}
                <nav className="hidden lg:flex items-center h-full gap-0" data-id="element-1078">
                  <button onClick={() => setIsOpen(!isOpen)} onMouseEnter={() => setIsOpen(true)} className={`flex items-center h-full px-5 text-sm font-bold border-b-2 transition-all ${isOpen ? 'border-[#0052CC] text-[#0052CC]' : 'border-transparent text-[#0A1628] hover:text-[#0052CC]'}`} data-id="element-1079">
                    Lorem Ipsum
                    <ChevronDown className={`ml-1.5 h-3.5 w-3.5 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-1080" />
                  </button>
                  {navItems.map(item => <button key={item} className="flex items-center h-full px-5 text-sm font-medium text-slate-500 border-b-2 border-transparent hover:text-[#0A1628] hover:border-slate-300 transition-all" data-id="element-1081">
                      {item}
                    </button>)}
                </nav>

                {/* Right */}
                <div className="flex items-center gap-1" data-id="element-1082">
                  <div className="hidden md:flex relative mr-2" data-id="element-1083">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" data-id="element-1084" />
                    <input readOnly placeholder="Search products..." className="w-48 pl-9 pr-4 py-2 bg-slate-50 border border-slate-200 text-sm placeholder:text-slate-400 focus:outline-none" data-id="element-1085" />
                  </div>
                  <button className="hidden sm:flex items-center gap-2 px-5 py-2 bg-[#0A1628] text-white text-sm font-bold hover:bg-[#0052CC] transition-colors" data-id="element-1086">
                    <ShoppingCart className="h-4 w-4" data-id="element-1087" />
                    Order Now
                  </button>
                  <button className="p-2.5 text-slate-500 hover:text-[#0A1628] hover:bg-slate-50 transition-colors" data-id="element-1088">
                    <User className="h-5 w-5" data-id="element-1089" />
                  </button>
                  <button className="relative p-2.5 text-slate-500 hover:text-[#0A1628] hover:bg-slate-50 transition-colors" data-id="element-1090">
                    <ShoppingBag className="h-5 w-5" data-id="element-1091" />
                    <span className="absolute top-1 right-1 h-3.5 w-3.5 bg-[#0052CC] text-white text-[9px] font-bold flex items-center justify-center" data-id="element-1092">
                      0
                    </span>
                  </button>
                </div>
              </div>
            </div>

            {/* Mega menu */}
            <AnimatePresence data-id="element-1093">
              {isOpen && <motion.div initial={{
              opacity: 0,
              y: -6
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -6
            }} transition={{
              duration: 0.18,
              ease: 'easeOut'
            }} onMouseLeave={() => setIsOpen(false)} className="bg-white border-b border-slate-200 shadow-xl" data-id="element-1094">
                  <div className="px-8 py-8" data-id="element-1095">
                    <div className="grid grid-cols-5 gap-0 divide-x divide-slate-100" data-id="element-1096">
                      {/* 4 product columns */}
                      {megaColumns.map((col, colIndex) => {
                    const Icon = col.icon;
                    return <div key={col.heading} className={`${colIndex === 0 ? 'pr-8' : 'px-8'}`} data-id="element-1097">
                            {/* Column heading */}
                            <div className="flex items-center gap-2 mb-5 pb-3 border-b border-slate-100" data-id="element-1098">
                              <Icon className="h-4 w-4 text-[#0052CC] flex-shrink-0" data-id="element-1099" />
                              <p className="text-xs font-bold text-[#0A1628] uppercase tracking-widest" data-id="element-1100">
                                {col.heading}
                              </p>
                            </div>
                            <ul className="space-y-0" data-id="element-1101">
                              {col.items.map(item => <li key={item.name} data-id="element-1102">
                                  <a href="#" className="group block py-2.5 border-b border-slate-50 hover:border-slate-100 transition-colors" data-id="element-1103">
                                    <p className="text-sm font-semibold text-[#0A1628] group-hover:text-[#0052CC] transition-colors" data-id="element-1104">
                                      {item.name}
                                    </p>
                                    <p className="text-xs text-slate-400 mt-0.5 leading-relaxed" data-id="element-1105">
                                      {item.desc}
                                    </p>
                                  </a>
                                </li>)}
                            </ul>
                            <a href="#" className="inline-flex items-center mt-4 text-xs font-bold text-[#0052CC] uppercase tracking-wider hover:text-[#0040A0] transition-colors" data-id="element-1106">
                              View all <ArrowRight className="ml-1 h-3 w-3" data-id="element-1107" />
                            </a>
                          </div>;
                  })}

                      {/* Feature column */}
                      <div className="pl-8" data-id="element-1108">
                        <div className="bg-[#0A1628] h-full flex flex-col" data-id="element-1109">
                          {/* Image area */}
                          <div className="bg-slate-800 flex items-center justify-center min-h-[160px] border-b border-slate-700" data-id="element-1110">
                            <div className="text-center" data-id="element-1111">
                              <Package className="h-10 w-10 text-slate-600 mx-auto mb-2" data-id="element-1112" />
                              <span className="text-xs text-slate-600 uppercase tracking-wider" data-id="element-1113">
                                Image
                              </span>
                            </div>
                          </div>
                          {/* Text */}
                          <div className="p-5 flex-1 flex flex-col" data-id="element-1114">
                            <p className="text-sm font-bold text-white mb-2 leading-snug" data-id="element-1115">
                              Lorem ipsum dolor sit amet consectetur adipiscing
                            </p>
                            <p className="text-xs text-slate-400 mb-5 leading-relaxed flex-1" data-id="element-1116">
                              Sed do eiusmod tempor incididunt ut labore et
                              dolore magna aliqua.
                            </p>
                            <div className="space-y-2" data-id="element-1117">
                              <a href="#" className="flex items-center justify-center w-full py-2.5 bg-[#0052CC] text-white text-xs font-bold hover:bg-[#0040A0] transition-colors" data-id="element-1118">
                                Lorem ipsum →
                              </a>
                              <a href="#" className="flex items-center justify-center w-full py-2 text-xs text-slate-400 hover:text-white transition-colors border border-slate-700 hover:border-slate-500" data-id="element-1119">
                                Consectetur adipiscing
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>

            {/* Page content stub */}
            <div className="bg-[#F4F5F7] px-8 py-16 flex items-center justify-center" data-id="element-1120">
              <div className="text-center space-y-3" data-id="element-1121">
                <div className="w-64 h-2 bg-slate-200 mx-auto" data-id="element-1122" />
                <div className="w-48 h-2 bg-slate-100 mx-auto" data-id="element-1123" />
                <div className="w-56 h-2 bg-slate-100 mx-auto" data-id="element-1124" />
              </div>
            </div>
          </div>

          <p className="text-center text-sm text-slate-400 mt-6" data-id="element-1125">
            Click or hover "Lorem Ipsum" in the nav above to toggle the mega
            menu
          </p>
        </div>
      </div>

      <Footer data-id="element-1126" />
    </div>;
}